<template>
  <div class="tutorials" @click="remove()" :style="styleObject" v-if="currentView !== false">
    <transition name="fade">
      <component v-bind:is="currentView"></component>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'tutorials',
  data () {
    return {}
  },
  computed: {
    currentView () {
      return this.$store.state.pagetutorial
    },
    styleObject () {
      let levelnav = _.head(document.getElementsByClassName('l-mainwrap__main__navigation'))
      let height = (levelnav !== undefined) ? levelnav.offsetHeight : 0
      return {
        top: height + 'px'
      }
    }
  },
  methods: {
    remove () {
      this.$store.state.pagetutorial = false
    }
  }
}
</script>

<style lang="scss">
  @import '~@/components/sass/shared/colors';

  .tutorials{
    background: transparentize($blue, 0.5);
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutorials/Tutorials.vue